import Editor from 'react-simple-code-editor';
import Prism from 'prismjs';
import 'prismjs/components/prism-css';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/themes/prism.css';
import { useEffect, useState } from 'react';
import './edit-html.scss';

interface Props {
	onChange: (html: string) => void;
	defaultValue: string;
}

export default function CustomHTML({
	onChange,
	defaultValue,
}: Props): JSX.Element {
	const [code, setCode] = useState(defaultValue);

	function updateCode(code: string) {
		setCode(code);
	}

	function highlight(code: any) {
		return Prism.highlight(code, Prism.languages.html, 'html');
	}

	async function handleBlur() {
		const div = document.createElement('div');
		div.innerHTML = code;
		setCode(div.innerHTML);
	}

	useEffect(() => {
		onChange(code);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [code]);

	return (
		<div className="custom-html-container">
			<Editor
				value={code}
				className="style-editor"
				onValueChange={updateCode}
				onBlur={handleBlur}
				highlight={highlight}
				padding={10}
				style={{
					fontFamily: 'Roboto Mono',
					fontSize: 12,
				}}
			/>
		</div>
	);
}
